import React from 'react';
import { SERVICES_DATA } from '../constants';

const Services: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Nuestros Servicios Médicos</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            Ofrecemos una amplia gama de especialidades para cubrir todas tus necesidades de salud en un solo lugar.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {SERVICES_DATA.map((service, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg text-center transform hover:-translate-y-2 transition-transform duration-300"
            >
              <div className="flex justify-center items-center">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-secondary dark:text-white mt-4 mb-2">{service.name}</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">{service.description}</p>
              <a href="#" className="font-bold text-primary transition-colors duration-300">
                Ver más &rarr;
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;